<script setup lang="ts">
import { onMounted, ref, shallowRef } from 'vue';

const map = shallowRef<google.maps.Map>();
const mapElement = ref<HTMLDivElement>();

type Props = {
  location: {
    longitude?: string;
    latitude?: string;
  };
};

const props = defineProps<Props>();

const longitude = parseFloat(props.location.longitude || '53.2156592');
const latitude = parseFloat(props.location.latitude || '6.5753275');

onMounted(async () => {
  const { Map } = (await google.maps.importLibrary('maps')) as google.maps.MapsLibrary;
  const { AdvancedMarkerElement } = (await google.maps.importLibrary('marker')) as google.maps.MarkerLibrary;

  if (!mapElement.value) return;

  map.value = new Map(mapElement.value, {
    center: { lat: latitude, lng: longitude },
    zoom: 13,
    mapId: '1234',
  });

  new AdvancedMarkerElement({
    map: map.value,
    position: { lat: latitude, lng: longitude },
  });
});
</script>

<template>
  <div ref="mapElement" class="google-maps"></div>
</template>

<style scoped>
.google-maps {
  width: 100%;
  height: 300px;
  min-height: 300px;
}
</style>
